<template>
  <section id="gallery"
           class="gallery module"
           v-if="album">
    <div class="container">
      <h2>{{ album.name }}</h2>

      <div id="photos" class="row">
        <div class="col-xs-12">
          <app-photo v-for="(photo, index) in album.photos"
                     :key="photo.id"
                     :photo="photo"
                     :index="index"
                     :active="photo.id === activePhoto"
                     @newActive="changeMenu($event)">
          </app-photo>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import axios from '@/axios-conf'
import Photo from '@/components/Photo.vue'

export default {
  data () {
    return {
      album: null,
      activePhoto: null
    }
  },
  props: {
    galleryId: {
      type: Number,
      default: null
    }
  },
  created () {
    axios.get('/api/album/2/')
      .then(res => {
        this.album = res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
  components: {
    appPhoto: Photo
  },
  methods: {
    changeMenu (payload) {
      if (payload.status) {
        this.activePhoto = payload.photoId
      } else {
        this.activePhoto = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  #gallery {
    background: #000;
    padding: 40px 0 60px;

    h2 {
      color: $font-light;
      margin-bottom: 20px;
    }

    .photo {
      border: 4px solid #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue